import React from "react";

import { findRel } from "../../../shared/utils/stringUtilities";

import "./button.scss";

const Button = (props: ButtonInterface) => {
  const {
    id,
    type,
    classname,
    text,
    onClickAction,
    isDisabled,
    href,
    icon,
    gtmMark,
    strictCss,
    target,
  } = props;

  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };

  return (
    <>
      {text ? (
        type === "button" ? (
          <button
            id={id}
            className={`${
              strictCss ? "" : "a-button "
            } ${classname} ${gtmMark}`}
            disabled={isDisabled}
            onClick={onClickAction}
          >
            {icon && <span className={`${icon}`} />}
            {text}
          </button>
        ) : type === "link" ? (
          <a
            id={id}
            href={href}
            target={isHttp(href) ? "_blank" : target || "_self"}
            rel={findRel(href)}
            className={`${
              strictCss ? "" : "a-button "
            } ${classname} ${gtmMark}`}
          >
            {icon && <span className={`${icon}`} />}
            {text}
          </a>
        ) : (
          <input
            className={`${
              strictCss ? "" : "a-button "
            } ${classname} ${gtmMark}`}
            type="submit"
            value={text}
            disabled={isDisabled}
          />
        )
      ) : (
        <></>
      )}
    </>
  );
};

interface ButtonInterface {
  id?: string;
  type: "button" | "input" | "link";
  classname: string;
  text: string | null | undefined;
  onClickAction?: () => any;
  isDisabled: boolean | undefined;
  icon?: string;
  href?: string;
  gtmMark?: string;
  strictCss?: boolean;
  target?: string;
}

export default Button;
